import { Amplify } from 'aws-amplify';

const awsConfig = {
  Auth: {
    Cognito: {
      userPoolId: import.meta.env.VITE_USER_POOL_ID,
      userPoolClientId: import.meta.env.VITE_USER_POOL_CLIENT_ID,
      signUpVerificationMethod: 'code' as const,
      loginWith: {
        email: true,
      },
    },
  },
  API: {
    REST: {
      AlmorzAppAPI: {
        endpoint: import.meta.env.VITE_API_URL,
        region: import.meta.env.VITE_REGION || 'us-east-1',
      },
    },
  },
};

Amplify.configure(awsConfig);

export default awsConfig;
